import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { ENTITY_NAMES, RECORD_STATUS_VALUES, TABLE_OPTION_VALUES } from '../../shared/constants/api-constants';
import { FilterPopoverComponent } from '../../shared/popover/filter-popover/filter-popover.component';
import { FilterService } from '../../shared/services/filter/filter.service';
import { Subscription } from 'rxjs';
import { UniversalSearchService } from '../../shared/services/search/universal-search.service';
import { FilterDestinationPopoverComponent } from '../../shared/popover/filter-destination-popover/filter-destination-popover.component';
import { StateManagementService } from '../../shared/services/state-management/state-management.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { InventoryItineraryGridViewComponent } from '../inventory-itinerary-grid-view/inventory-itinerary-grid-view.component';

interface InventoryItem {
  itineraryId: string;
  itineraryName: string;
  destination: string[] | string;
  totalDays: number;
  status: string;
}
@Component({
  selector: 'app-itinerary-list',
  templateUrl: './itinerary-list.component.html',
  styleUrls: ['./itinerary-list.component.scss'],
})
export class ItineraryListComponent implements OnInit {
  @ViewChild(InventoryItineraryGridViewComponent) gridViewComponent!: InventoryItineraryGridViewComponent;

  // Subscriptions
  private searchSubscription: Subscription | undefined;

  originalInventoryList: any;
  alloriginalInventoryList: any;
  allInventoryItineraryData: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };;
  allInventoryItineraryColumns: any = [
    {
      key: "itineraryId",
      colName: "Itinerary ID",
      showColumn: true,
      cssClass: "id-column",
      emitRowOnClick: true,
      isDisabled: true
    },
    {
      key: "itineraryName",
      colName: "Name",
      showColumn: true,
      cssClass: "itinerary-name-column",
      isDisabled: true
    },
    {
      key: "locationArray",
      colName: "Destination",
      showColumn: true,
      isDisabled: true
    },
    {
      key: "totalDays",
      colName: "Nights",
      showColumn: true,
      cssClass: 'no-of-days-column'
    },
    {
      key: "status",
      colName: "Status",
      showColumn: true,
      cssClass: 'status-column',
      isDisabled: true
    },
    {
      key: "approxCost",
      colName: "Approx Cost",
      showColumn: true,
      cssClass: ''
    },
    {
      key: "showInWebsite",
      colName: "Show in website",
      showColumn: true,
      cssClass: ''
    },
    {
      key: "imagePath",
      colName: "Banner Image",
      showColumn: true,
      cssClass: ''
    },
    {
      key: "itineraryType",
      colName: "Itinerary Type",
      showColumn: true,
      cssClass: ''
    },
  ];
  itineraryOptions: any = {
    idKey: "itineraryId",
    options: [
      {
        value: "View",
        path: TABLE_OPTION_VALUES.VIEW
      },
      {
        value: "Edit",
        path: TABLE_OPTION_VALUES.EDIT
      },
      {
        value: "Delete",
        path: TABLE_OPTION_VALUES.DELETE
      }
    ]
  }


  inventoryItineraryStatusLov: any = [
    {
      key: RECORD_STATUS_VALUES.PENDING,
      name: RECORD_STATUS_VALUES.PENDING
    },
    {
      key: RECORD_STATUS_VALUES.APPROVED,
      name: RECORD_STATUS_VALUES.APPROVED
    }
  ]

  role: any;
  showItineraryButton: any;
  itineraryPermissions: any;

  inventoryFilters: any = { "destination": [], "totalDays": [], "status": [], "createdBy": [], "startDate": [], "endDate": [] };
  // Pagination settings
  paginationSettings: any = {
    pageNumber: 1,
    pageSize: 10
  }

  ENTITY_NAMES = ENTITY_NAMES;
  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;

  // date range
  fromDate!: string;
  toDate!: string;

  showFilters: boolean = false;
  itineraryFilterStatusLov: any = [];
  activeVisibleStatusFilters: any[] = [];

  constructor(
    private _inventoryService: InventoryService,
    private _globalService: GlobalService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _lovDataService:LovDataService,
    private _popoverController: PopoverController,
    private _filterService: FilterService,
    private _universalSearchService: UniversalSearchService,
    private _stateManagementService: StateManagementService,
    private _responseNotificationService: ResponseNotificationService
  ) { }

  async ngOnInit() {

    this.allInventoryItineraryColumns = this._stateManagementService.getTableColumns(ENTITY_NAMES.INVENTORY_ITINERARY)?.length ? this._stateManagementService.mergeManageColumnsStates(this._stateManagementService.getTableColumns(ENTITY_NAMES.INVENTORY_ITINERARY), this.allInventoryItineraryColumns) : this.allInventoryItineraryColumns;
    let storedFilters = this._stateManagementService.getFilters(ENTITY_NAMES.INVENTORY_ITINERARY);
    if (storedFilters) {
      let updatedFilters: any = {};

      for (const key in storedFilters) {
        if (storedFilters.hasOwnProperty(key) && storedFilters[key].length > 0) {
          if (key === "ownership") {
            let ownershipData = await this.getColumnData(ENTITY_NAMES.USER, "name");
            updatedFilters[key] = ownershipData.filter((ownership: any) => storedFilters[key].includes(ownership.data));
          } else {
            updatedFilters[key] = storedFilters[key].map((item: any) => ({ key: item, data: item }));
            if(key === "startDate"){
              this.fromDate = updatedFilters[key][0]?.key || '';
            }
            if(key === "endDate"){
              this.toDate = updatedFilters[key][0]?.key || '';
            }
          }
        }
      }

      this.inventoryFilters = {
        ...this.inventoryFilters,
        ...updatedFilters
      };
    }

    this.itineraryFilterStatusLov = await this.getColumnData(ENTITY_NAMES.INVENTORY_STATUS, "name");

    this.role = localStorage.getItem("Role");
    this._globalService.roles$.subscribe((roles) => {
      if (roles) {
        const itineraryModule = roles.modules.find((module: any) => module.name === "Inventory");
        this.itineraryPermissions = itineraryModule.permissions;
        this.updateActionsForRoles();
      }
    })

    this.getDefaultInventoryItinerary();

    this.searchSubscription = this._universalSearchService.searchValueChanged.subscribe(() => {
      this.getDefaultInventoryItinerary(); // Trigger task loading based on updated search value
    });

    this._reloadService.reloadInventoryItinerary$.subscribe(() => {
      this.getDefaultInventoryItinerary();
    })

  }

  manageColumnsChanged(event: any) {
    this._stateManagementService.setTableColumns(ENTITY_NAMES.INVENTORY_ITINERARY, event)
  }

  // date range 
  onFromDateChange(event: any) {
    if (this.toDate && new Date(this.toDate) < new Date(event)) {
      this.toDate = ''; // Reset toDate if it's less than fromDate
    }

    if (!event) {
      this.toDate = '';
    }
    this.inventoryFilters.startDate = [this.fromDate];
    this.setFiltersState();
    this.getDefaultInventoryItinerary();

  }

  onToDateChange(event: any) {
    this.inventoryFilters.endDate = [this.toDate];
    this.setFiltersState();
    this.getDefaultInventoryItinerary();
  }

  get today() {
    return this._globalService.getTodaysDate();
  }
  // date range

  clearFilters() {
    // match the structure with the initial value
    this.inventoryFilters = { "destination": [], "totalDays": [], "status": [], "createdBy": [], "startDate": [], "endDate": [] };
    this.fromDate = '';
    this.toDate = '';
    this.setFiltersState();
    this.getDefaultInventoryItinerary();
  }

  setFiltersState() {
    this._stateManagementService.setFilters(ENTITY_NAMES.INVENTORY_ITINERARY, this._globalService.convertDataToStrings(this.inventoryFilters));
  }

  async openFiltersPopup(event: Event, columnName: string, entityName: string, otherColumnName: any) {
    // do api call and pass to the listOfValues
    let listOfValues: any = [];
    if (entityName === 'Nights') {
      // Generate values from 1 to 100
      listOfValues = Array.from({ length: 100 }, (_, i) => i + 1).map((value) => ({
        key: value.toString(),
        data: value
      }));
    } else {
      // Do API call and fetch data normally
      listOfValues = await this.getColumnData(entityName, columnName);
    }
    // listOfValues = listOfValues.map((item: { data: any; }) => item.data)
    listOfValues = listOfValues.map((item: { key: string; data: any }) => ({
      key: item.key,
      data: item.data,
    }));



    if (listOfValues) {
      const emitCheckedItems = new EventEmitter<any[]>();
      const popover = await this._popoverController.create({
        component: FilterPopoverComponent,
        event: event,
        cssClass: 'filter-popover-component',
        componentProps: {
          entityName: entityName,
          listOfValues: listOfValues,
          columnName: columnName,
          checkedListOfValues: otherColumnName ? this.inventoryFilters[otherColumnName] : this.inventoryFilters[columnName],
          emitCheckedItems: emitCheckedItems
        }
      });

      emitCheckedItems.subscribe((checkedItems: any) => {
        if (otherColumnName) {
          this.inventoryFilters[otherColumnName] = checkedItems;
        }
        else {
          this.inventoryFilters[columnName] = checkedItems;
        }
        this.setFiltersState();
        this.getDefaultInventoryItinerary();

      })
      return await popover.present();
    }
  }


  async openDestinationFiltersPopup(event: Event, columnName: string, entityName: string, otherColumnName: any) {

    const emitSelectedLocation = new EventEmitter<any>();
    const popover = await this._popoverController.create({
      component: FilterDestinationPopoverComponent,
      event: event,
      cssClass: 'filter-popover-component',
      componentProps: {
        emitSelectedLocation: emitSelectedLocation
      }
    });

    emitSelectedLocation.subscribe((selectedLocation: string) => {
      if (otherColumnName) {
        this.inventoryFilters[otherColumnName] = [selectedLocation];
      }
      else {
        this.inventoryFilters[columnName] = [selectedLocation];
      }
      const hasValue = Object.values(this.inventoryFilters).some(
        (property) => Array.isArray(property) && property.length > 0
      );
      this.setFiltersState();
      this.getDefaultInventoryItinerary()

    })
    return await popover.present();

  }


  async getColumnData(entityName: string, columnName: string): Promise<any> {
    try {
      const response = await this._filterService.getLovColumnData(entityName, columnName).toPromise();
      return response;
    } catch (error) {
      return null;
    }
  }


  updateActionsForRoles() {
    this.showItineraryButton = this.itineraryPermissions.createItinerary;

    // resetting options to empty array
    this.itineraryOptions.options = [];

    // Appending respective options according to role permissions
    if (this.itineraryPermissions.viewItinerary) {
      this.itineraryOptions.options.push({
        value: "View",
        path: TABLE_OPTION_VALUES.VIEW
      });
    }
    if (this.itineraryPermissions.editItinerary) {
      this.itineraryOptions.options.push({
        value: "Edit",
        path: TABLE_OPTION_VALUES.EDIT
      });
    }
    this.itineraryOptions.options.push({ value: "Audit History", path: TABLE_OPTION_VALUES.SHOW_AUDIT });
    if (this.itineraryPermissions.deleteItinerary) {
      this.itineraryOptions.options.push({
        value: "Delete",
        path: TABLE_OPTION_VALUES.DELETE
      });
    }
  }

  getDefaultInventoryItinerary() {
    this._inventoryService.getAllInventoryItinerary(this.paginationSettings?.pageNumber, this.paginationSettings?.pageSize, null, this._universalSearchService.getSearchValue(), this._globalService.convertDataToStrings(this.inventoryFilters)).subscribe((data) => {
      this.allInventoryItineraryData = data;
      this.originalInventoryList = this.allInventoryItineraryData.data;
      this.allInventoryItineraryData.data = this.allInventoryItineraryData.data.map((itinerary: any) => ({
        ...itinerary,
        statusLov: this.inventoryItineraryStatusLov,
        locationArray: itinerary.destination ? itinerary.destination.map((d: any) => (this._globalService.getFirstItemOfString(d.location)) + `(${d.days})`) : [],
      }))
    });
  }
  columnConfig: { key: string; title: string }[] = [
    { key: 'itineraryId', title: 'Itinerary ID' },
    { key: 'itineraryName', title: 'Name' },
    { key: 'destination', title: 'Destination' },
    { key: 'totalDays', title: 'Nights' },
    { key: 'status', title: 'Status' }
  ];

  downloadInventoryCSV(): void {
    this._inventoryService.getAllInventoryItinerary(-1, -1, null, this._universalSearchService.getSearchValue(), this._globalService.convertDataToStrings(this.inventoryFilters)).subscribe((data) => {
      this.alloriginalInventoryList = data.data;
      const moduleName = "Inventory_Itinerary";
      const currentDate = new Date();
      const formattedDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}${String(currentDate.getDate()).padStart(2, '0')}${currentDate.getFullYear()}`;
      const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}${String(currentDate.getMinutes()).padStart(2, '0')}${String(currentDate.getSeconds()).padStart(2, '0')}`;
      const fileName = `TM_${moduleName}_${formattedDate}_${formattedTime}`;

      const formattedData = this.alloriginalInventoryList.map((item: any) => {
        let formattedDestination = '';

        if (item.destination && Array.isArray(item.destination) && item.destination.length > 0) {
          formattedDestination = item.destination[0].location || 'Unknown Location';
        } else {
          formattedDestination = item.destination ? item.destination.toString() : '';
        }

        return {
          ...item,
          destination: formattedDestination || ''
        };
      });
      this._globalService.convertToCSV(formattedData, this.columnConfig, fileName);
    });
  }

  openNewItineraryForm() {
    this._modalPopupService.openItineraryForm(null, null, null, null, null);
  }

  async deleteItineraryRow(itineraryId: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${itineraryId}`, "Confirm Delete", "Yes")) {
      this._inventoryService.deleteInventoryItinerary(itineraryId).subscribe(async (data) => {
        await this._responseNotificationService.showMessage("Itinerary Deleted Successfully");
        this.ngOnInit()
      })
    }

  }

  editItineraryOpen(data: any) {
    this._modalPopupService.openItineraryForm(null, null, null, data, null);
  }

  viewInventoryItinerary(data: any) {
    // this.openInventoryItineraryView(data);
    this._modalPopupService.openInventoryItineraryView(data, null, null);
  }

  // Change status fo inventory itinerary status
  changeInventoryItineraryStatus(event: any) {
    let inventoryItinerary: any;
    let inventoryId = event.row.itineraryId;
    this._inventoryService.getInventoryItinerary(inventoryId).subscribe((data) => {
      inventoryItinerary = data;
      inventoryItinerary.itineraryDetails.status = event.statusValue;
      this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe((data) => {
        this._reloadService.triggerInventoryItineraryReload();
      })
    })
  }

  // Get all Itinerary when paginations updated
  updatePagination(paginationData: any) {
    this.paginationSettings = paginationData
    this.getDefaultInventoryItinerary();
  }

  async deleteMultipleRow() {
    if (await this._globalService.confirmActionPopup("Are you sure to delete multiple Itineraries at once?", "Confirm multi delete", "Yes")) {
      let selectedRows = this.gridViewComponent.getSelectedRows();
      let selecteRows = selectedRows.map((row: any) => row.itineraryId);

      if (selecteRows && selecteRows.length) {
        let req = {
          ids: selecteRows,
          actions: {
            isDeleted: true
          }
        }

        this._inventoryService.performBulkActions(req).subscribe({
          next: (res) => {
            this._reloadService.triggerInventoryItineraryReload();
            this._responseNotificationService.showMessage("Leads deleted successfully");
          }
        })
      }
    }
  }

  showAuditHistory(id: any) {
    this._lovDataService.getAuditData(id, "Itinerary").subscribe((data) => {
      this._modalPopupService.openAuditHistoryView(ENTITY_NAMES.INVENTORY_ITINERARY, id, data, `Itinerary (${id})`);
    });
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }
  
  getStatusCount(status: string): number {
    const statusObj = this.itineraryFilterStatusLov.find((item: any) => item.key === status);
    return statusObj ? statusObj.count : 0;
  }

  toggleStatusFilter(status: string) {
    const statusObj = this.itineraryFilterStatusLov.find((item: any) => item.key === status);
    if (this.activeVisibleStatusFilters.includes(statusObj)) {
      this.activeVisibleStatusFilters = this.activeVisibleStatusFilters.filter((item: any) => item.key !== statusObj.key);
    } else {
      this.activeVisibleStatusFilters.push(statusObj);
    }
    this.inventoryFilters['status'] = this.activeVisibleStatusFilters;
    this.getDefaultInventoryItinerary();
  }

  checkIfStatusActive(status: string): boolean {
    const statusObj = this.itineraryFilterStatusLov.find((item: any) => item.key === status);
    return this.activeVisibleStatusFilters.includes(statusObj);
  }

  toggleAllStatusFilters() {
    this.activeVisibleStatusFilters = [];
    this.inventoryFilters['status'] = [];
    this.getDefaultInventoryItinerary();
  }

  isAllStatusFiltersActive(): boolean {
    if(this.activeVisibleStatusFilters.length === 0) {
      return true;
    }else {
      return false;
    }
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
  }
}
